import createPriceFormatter from "./createPriceFormatter.js";
export default function createCurrencySymbolFormatter(locale, defaultCurrency) {
  return (currency = defaultCurrency, options = {}) => createPriceFormatter(locale, currency)(
    { amount: "0.00", currency },
    options
  ).replace(/[\d.,\s]/g, "").trim();
}
